export const HD_INDUSTRY_ID = "d8ae0982-aef0-4e1c-8a7b-c174a87811e2";
export const HD_GROUP = "HDLectureManager";

export function isHDLectureManager(user) {
    return !!user?.["cognito:groups"]?.includes(HD_GROUP);
}

export function hasHDIndustry(event) {
    return !!event?.industries?.items?.some(
        (i) => i?.industry?.id === HD_INDUSTRY_ID
    );
}
